// Disabled old Appwrite auth system — using PIN login instead
export const authManager = {
    user: null,
    onAuthStateChanged() {},
    signInWithGoogle() {},
    signInWithEmail() {},
    signUpWithEmail() {},
    sendPasswordReset() {},
    signOut() {},
};
